module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AI-a9c45683231ff71002b398413a7c11e9.png";